import React, { useState, useEffect } from "react"
import Container from "@/components/container"
import AllSolutions from "../all-solutions"
import * as styles from "./index.module.scss"
import cls from "classnames"
import { graphql, useStaticQuery } from "gatsby"
import queryString from "querystring"
import { STORAGE_KEY } from "@/constants/common"

const Categories = () => {
  const [category, setCategory] = useState("")
  const [tag, setTag] = useState("" as string)
  const [tags, setTags] = useState([] as string[])

  const fetchCategories = useStaticQuery<AllStrapiSolutionCategories>(graphql`
    query fetchCategories {
      allStrapiSolutionCategories {
        edges {
          node {
            id
            Category
            tags
          }
        }
      }
    }
  `)
  const {
    allStrapiSolutionCategories: { edges },
  } = fetchCategories

  const setCurrentCategory = (currentCategory: {
    id: string
    tags: string[]
    Category: string
  }) => {
    window.history.replaceState(
      null,
      "",
      "?category=" + currentCategory.Category
    )
    sessionStorage.setItem(STORAGE_KEY.SOLUTION, currentCategory.Category)
    setCategory(currentCategory.Category)
    setTags(currentCategory.tags)
    setCurrentTag("")
  }

  const setCurrentTag = (currentTag: string) => {
    setTag(currentTag)
  }

  useEffect(() => {
    const { category } = queryString.parse(
      typeof window !== "undefined"
        ? window.location.search.replace("?", "")
        : ""
    ) as { [key: string]: string }
    const defaultNode = edges.find(({ node }) => node.Category === category)
      ?.node
    const node = category && defaultNode ? defaultNode : edges[0].node
    if (defaultNode) {
      document?.getElementById("categories")?.scrollIntoView()
    }
    setCurrentCategory(node)
  }, [edges])
  return (
    <div id="categories" className={styles.container}>
      <Container>
        <h1 className={cls(styles.h1, styles.title)}>全部解决方案</h1>
        <header className={styles.tabBar}>
          <ul className={styles.categories}>
            {edges.map(({ node }) => (
              <li
                className={category === node.Category ? styles.isActive : null}
                key={node.id}
                onClick={() => setCurrentCategory(node)}
              >
                {node.Category}
              </li>
            ))}
          </ul>
          {/* <div className={styles.tags}>
            <span
              className={cls(styles.tag, tag === "" ? styles.isActive : null)}
              onClick={() => setCurrentTag("")}
            >
              全部
            </span>
            {tags.map((item, index) => (
              <span
                className={cls(
                  styles.tag,
                  tag === item ? styles.isActive : null
                )}
                onClick={() => setCurrentTag(item)}
                key={index}
              >
                {item}
              </span>
            ))}
          </div> */}
        </header>
        <AllSolutions selectedTag={tag} allTags={tags} />
      </Container>
    </div>
  )
}

export default Categories
